import React from "react";

import { useOutsideClick } from "@common/hooks/outsideClick";

import "./style.scss";

const buttons = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."];

const NumericKeyboard = ({ customButtons, onClick, onRemove, onClose, outsideException }) => {
	const ref = useOutsideClick(onClose, [onClose], outsideException);

	return (
		<div ref={ref} className="T-terminal-numeric-keyboard">
			<div className="calc-top-section">
				{customButtons?.map(item => (
					<button type="button" key={item} onClick={() => onClick(item)}>
						{item}
					</button>
				))}
			</div>
			<div className="calc-action-buttons">
				{buttons.map(item => (
					<button type="button" key={item} onClick={() => onClick(item)}>
						{item}
					</button>
				))}
				<button onClick={onRemove} className="global-icon icon-backspace" />
			</div>
			<div className="for-done-button">
				<button type="button" onClick={onClose}>
					{" "}
					<span className="global-icon icon-icon-done" />
				</button>
			</div>
		</div>
	);
};

export default NumericKeyboard;
